import { Component, OnInit } from '@angular/core';
import { MyAccountService } from '../_services/my-account.service';
import { NotificationService } from '../_services/notification.service';
import { AuthService } from '../_services/auth.service';
import { LoadingBarService } from '@ngx-loading-bar/core';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material';

@Component({
  selector: 'app-my-account',
  templateUrl: './my-account.component.html',
  styleUrls: ['./my-account.component.css']
})
export class MyAccountComponent implements OnInit {

  // selectedImage: string | ArrayBuffer | null = null;

  constructor(
    public myAccountService: MyAccountService,
    private notificationService: NotificationService,
    private dialog: MatDialog,
    private loading: LoadingBarService,
    private authService: AuthService,
    private router: Router,
  ) { }

  ngOnInit() {
    this.onLoadUserData();
  }


  onLoadUserData() {
    const accessToken = this.authService.getToken();
    if (!accessToken) {
      this.authService.logout();
    }
    else {
      this.authService.validate_token().subscribe((data: any) => {
        if (data.status) {
          this.authService.user_dept = data.user;
          const user = this.authService.user_dept;
          console.log('User Data:', user);
          // console.log(String(user.role));
          this.myAccountService.myAccountForm.patchValue({
            fullname: user.name,
            email: user.email,
            // mobile: user.mobile,
            role: String(user.role),
            //profilePhoto: user.profilePhoto,
          });
        }
        else {
          this.authService.logout();
        }
      });
    }
  }


  // onFileSelected(event: any) {
  //   const file = event.target.files[0];
  //   if (file) {
  //     const reader = new FileReader();
  //     reader.onload = e => this.selectedImage = reader.result;
  //     reader.readAsDataURL(file);
  //   }
  // }

  onMyAccountUpdate() {
    if (this.myAccountService.myAccountForm.valid) {
      // this.loading.spin$.next(true);
      this.myAccountService.update_account(this.myAccountService.myAccountForm.value).subscribe((data: any) => {
        // console.log(data);
        // this.loading.spin$.next(false);
        if (data.status) {
          this.notificationService.success(data['message']);
          this.myAccountService.myAccountForm.reset();
        }
        else {
          this.notificationService.error(data['message']);
        }
      });
    }
  }

  onChangePasswordSubmit() {
    if (this.myAccountService.changePasswordForm.valid) {
      // this.loading.spin$.next(true);
      
      const formValue = this.myAccountService.changePasswordForm.value;
      if (formValue.new_password !== formValue.confirm_new_password) {
        //this.loading.spin$.next(false);
        this.notificationService.error('New password and confirm password do not match.');
        return;
      }
      this.myAccountService.changePassword(formValue).subscribe((data: any) => {
        console.log(data);
        // this.loading.spin$.next(false);
        if (data.status) {
          this.notificationService.success(data['message']);
          this.myAccountService.changePasswordForm.reset();
        }
        else {
          this.notificationService.error(data['message']);
        }
      });
    }
  }

}
